module.exports = __webpack_public_path__ + "img/iconProjectStoreHouse.6806d918.svg";